import React, { useEffect, useState } from 'react'
import { Container, Row, Col, Form, Card, Button } from 'react-bootstrap'
import Swal from 'sweetalert2'
import Select from "react-select"
import { useTranslation } from "react-i18next"
import { useDispatch, useSelector } from 'react-redux'
import { createUser } from '../../actions/usersActions'
import { useNavigate } from 'react-router-dom'
import useAuth from '../../context/auth/useAuth'
import { getReducedSchools } from '../../actions/schoolsActions'

export default function CreateMultiSchool() {
    const { t } = useTranslation()
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const {client} = useAuth()

    const {schools} = useSelector(state=>state.schools)
    const {resultuser} = useSelector(state=>state.users)

    const [formState, setFormState] = useState({
        profile: "MultiSchool",
        active_first: true
    })

    const [schoolsOptions, setSchoolOptions] = useState([])


    const handleInputChange = ({target})=>{
        setFormState({
            ...formState,
            [target.name]: target.value
        })
    }

    const handleSelectLinesChange = (selectedValues) =>{
        setFormState({
            ...formState,
            'schools': selectedValues
        })
    }
    const handleAdd = async(e) => {
        e.preventDefault()

        if(formState.email !== null && formState.email !== '' && formState.email !== undefined && formState.password !== null && formState.password !== '' && formState.password !== undefined){
            dispatch(createUser(null, {
                ...formState,
                schools: formState.schools.map(school => school.value)
            }))
        }else{
            Swal.fire({
                showConfirmButton: true,
                icon: 'warning',
                text: t('users.pleasecomplete')
            })
        }
    }

    useEffect(() => {
        if (client && client?.rol === 'Superadmin') {
            dispatch(getReducedSchools())
        }
    }, [client, dispatch])

    useEffect(() => {
        if (schools) {
            setSchoolOptions(schools.map(school => {
                return { label: school.name, value: school.id }
            }))
        }
    }, [schools])

    useEffect(() => {
        if (resultuser) {
            dispatch({
                type: 'USER_RESET_RESULT'
            })
            switch (resultuser) {
                case 'success':
                    Swal.fire({
                        showConfirmButton: true,
                        showDenyButton: false,
                        confirmButtonText: t('global.great'),
                        icon: 'success',
                        text: t('admin.dashboard.addMultiSchoolSuccess')
                    })
                    navigate('/admin/multischools')
                    break
                default:
                    break
            }
        }
        // eslint-disable-next-line
    }, [resultuser, dispatch])

    return (
        <>
        	<Container className='cuerpo'>
				<Row>
                    <h1>{t('admin.dashboard.multiSchoolData')}</h1>
				</Row>
				<Row className="mt-2">
					<Col>
						<Card className='mb-5 sombra'>
                            <Card.Body className='px-5 pt-5'>
                                <Form onSubmit={handleAdd} autoComplete='off'>
                                    <Row>
                                        <Col xs='12' lg='6' className="my-2">
                                            <Form.Label>{t('signin.email')}</Form.Label>
                                            <Form.Control
                                                type='email'
                                                name='email'
                                                value={formState.email ||  ''}
                                                onChange={handleInputChange}
                                                required
                                            />
                                        </Col>
                                        <Col xs='12' lg='6' className="my-2">
                                            <Form.Label>{t('signin.password')}</Form.Label>
                                            <Form.Control
                                                type='password'
                                                name='password'
                                                value={formState.password ||  ''}
                                                onChange={handleInputChange}
                                                required
                                            />
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col xs='12' className="my-2">
                                            <Form.Label htmlFor='lines'>{t('users.chooselines')}</Form.Label>
                                            <Select
                                                className="select"
                                                name='lines'
                                                options={schoolsOptions}
                                                value={formState?.schools}
                                                onChange={handleSelectLinesChange}
                                                isMulti
                                            />
                                        </Col>
                                    </Row>
                                    <Row className="my-3 d-flex justify-content-end">
                                        <Col xs='12' lg='4'>
                                            <Button type="submit" className="btn-primary w-100 my-2">{t('admin.dashboard.createMultiSchool')}</Button>
                                        </Col>
                                    </Row>
                                </Form>
                            </Card.Body>
						</Card>
					</Col>
				</Row>
			</Container>
        </>
    )
}